import { render, staticRenderFns } from "./DashboardRestricted.vue?vue&type=template&id=5c8433f3"
import script from "./DashboardRestricted.vue?vue&type=script&lang=js"
export * from "./DashboardRestricted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports